import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV, fetchDataCallOnInitialLoad  } from "../../../common_nextgen/utils/UtilFunctions";

const useMaxCopaySchedule = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialSelectMode,
  initialLookupType
) => {
  const { axios_helper_no_header } = useAxios();

  const location = useLocation();
  const stateVal = location.state || [];

  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    paramsData: initialParamsData = {
      mcyMaxCopaySchedule: "",
    },
  } = currentState;

  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [data, setData] = useState([]); /* Max Copay Schedule Data */
  const [paramsData, setParamsData] = useState(initialParamsData); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const {
    ADD_MAX_COPAY_SCHEDULE,
    EDIT_MAX_COPAY_SCHEDULE,
    DISPLAY_MAX_COPAY_SCHEDULE,
    MAX_COPAY_STEPS,
    MAX_COPAY_DIFF_STEPS,
    MAX_COPAY_SCHEDULE_STEPS,
  } = ROUTE_PATHS;

  const screen_title = "Max Copay Schedule ";
  const screenNumber = selectMode ? "RCMCY004" : "RCMCY001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "MCY Max Copay Schedule",
      name: "mcyMaxCopaySchedule",
      label: "Schedule",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    if (lookupType === "external") {
      const message = { type: "hideModal" };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Max Copay Schedule",
          button_handeler: () => {
            navigateToPage(ROUTE_PATHS.ADD_MAX_COPAY_SCHEDULE, [
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramDataMap = new Map();
            selectParams.forEach((key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                paramDataMap.set(key["source"], rowData[key["target"]]);
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            if (lookupType !== "external") {
              onSelect(paramData);
            } else {
              const message = {
                type: "responseData",
                data: paramData,
              };
              window.parent.postMessage(message, "*");
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            const params = selectParams || [];
            const paramDataMap = new Map();
            params.forEach((item) => {
              if (rowData.hasOwnProperty(item["target"])) {
                paramDataMap.set(item["source"], rowData[item["target"]]);
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            const message = {
              type: "navigateData",
              data: paramData,
              target: "DISPLAY_MAX_COPAY_SCHEDULE",
            };
            console.log("display message", message);
            window.parent?.postMessage(message, "*");
          },
        },
        {
          label: "Max Copay Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            const params = selectParams || [];
            const paramDataMap = new Map();
            params.forEach((item) => {
              if (rowData.hasOwnProperty(item["paramDataKey"])) {
                paramDataMap.set(item["paramDataKey"], rowData[item["paramDataKey"]]);
              } else if (rowData.hasOwnProperty(item["target"])) {
                paramDataMap.set(item["source"], rowData[item["target"]]);
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            const message = {
              type: "navigateData",
              data: { ...paramData, additionalData: { type: "1" } },
              target: "MAX_COPAY_SCHEDULE_STEPS",
            };
            console.log("display message", message);
            window.parent?.postMessage(message, "*");
          },
        },
        {
          label: "Max Copay+Diff Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            const params = selectParams || [];
            const paramDataMap = new Map();
            params.forEach((item) => {
              if (rowData.hasOwnProperty(item["paramDataKey"])) {
                paramDataMap.set(item["paramDataKey"], rowData[item["paramDataKey"]]);
              } else if (rowData.hasOwnProperty(item["target"])) {
                paramDataMap.set(item["source"], rowData[item["target"]]);
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            const message = {
              type: "navigateData",
              data: { ...paramData, additionalData: { type: "3" } },
              target: "MAX_COPAY_SCHEDULE_STEPS",
            };
            console.log("display message", message);
            window.parent?.postMessage(message, "*");
          },
        },
      ]
    : [
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { mcyMaxCopaySchedule } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(ROUTE_PATHS.EDIT_MAX_COPAY_SCHEDULE, [
              ...previousState,
              {
                ...currentState,
                paramsData: {
                  ...paramsData,
                  mcyMaxCopaySchedule: mcyMaxCopaySchedule,
                },
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { mcyMaxCopaySchedule } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(ROUTE_PATHS.DISPLAY_MAX_COPAY_SCHEDULE, [
              ...previousState,
              {
                ...currentState,
                paramsData: { mcyMaxCopaySchedule: mcyMaxCopaySchedule },
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Max Copay Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { mcyMaxCopaySchedule } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(MAX_COPAY_SCHEDULE_STEPS, [
              ...previousState,
              {
                ...currentState,
                paramsData: {
                  ...paramsData,
                  mcyMaxCopaySchedule: mcyMaxCopaySchedule,
                },
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
                type: "1",
              },
            ]);
          },
        },
        {
          label: "Max Copay+Diff Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { mcyMaxCopaySchedule } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(MAX_COPAY_SCHEDULE_STEPS, [
              ...previousState,
              {
                ...currentState,
                paramsData: { mcyMaxCopaySchedule: mcyMaxCopaySchedule },
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                type: "3",
              },
            ]);
          },
        },
      ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "mcyMaxCopaySchedule",
    },
    {
      header: "Description",
      field: "mcyMaxCopayDescription",
    },
    {
      header: "Look-back Level",
      field: "mcyLookbackLevel",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "mcyMaxCopaySchedule";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/mcyMaxCopaySchedule`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
      fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, lookupType]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { mcyMaxCopaySchedule: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/mcyMaxCopaySchedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/mcyMaxCopaySchedule/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      setLookupType("external");
      setSelectParams(paramData.params);
      // setParamsData(paramData.paramsData);
      setParamsData({
        ...paramsData,
        ...paramData.paramsData,
      });
      setSelectMode(selectMode);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    leftButtons,
    selectMode,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
  };
};

export default useMaxCopaySchedule;
